module.exports = __webpack_public_path__ + "static/media/share_pintrest.7a98d8a7.svg";